'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle("/* \n* ink colors (with variations only for black and white)\n*/\n.lp-loader {\n  display: block;\n  margin: auto;\n  border: 2px solid;\n  border-radius: 50%;\n  animation: rotation 0.8s infinite linear;\n}\n.lp-loader.loader--sm {\n  height: calc(0.75 * 1rem);\n  width: calc(0.75 * 1rem);\n}\n.lp-loader.loader--md {\n  height: 14px;\n  width: 14px;\n}\n.lp-loader.loader--lg {\n  height: 16px;\n  width: 16px;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}");
//# sourceMappingURL=Loader.scss.js.map
